import Link from "next/link";
import { FC, useMemo } from "react";
import { Image } from "semantic-ui-react";
import NoSSR from "../NoSSR";

interface Props {
  locale: string;
}

const localeMapping: Record<string, string> = {
  "pl-pl": "en",
  en: "en",
  "en-se": "en",
  "en-dk": "en",
  "en-us": "en",
  "en-gb": "en",
  "nl-be": "en",
  nl: "en",
  de: "de",
  "de-at": "de",
};

const BCorpLogo: FC<Props> = ({ locale }) => {
  const bCorpLogoByLocale = useMemo(() => {
    const normalizedLocale = localeMapping[locale] || "en";

    return `/static/images/Bcorp/Bcorp-${normalizedLocale}.png`;
  }, [locale]);

  return (
    <NoSSR>
      <Link href="https://www.bcorporation.net/en-us/find-a-b-corp/company/otrium/">
        <Image width={60} alt="Certified Bcorp Logo" src={bCorpLogoByLocale} />
      </Link>
    </NoSSR>
  );
};

export { BCorpLogo };
